import {unset, initial, take, isEmpty, get} from 'lodash';

export function unsetAndCleanUpEmtpy(object, path = []) {
    unset(object, path);
    const cleanUpPath = initial(path);
    for (let numberToTake = cleanUpPath.length; numberToTake > 0; numberToTake--) {
        const currentCleanUpPath = take(cleanUpPath, numberToTake);
        if (!isEmpty(get(object, currentCleanUpPath))) {
            break;
        }
        unset(object, currentCleanUpPath);
    }
}
